// exemplo base
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import Card from '@/components/Card';
import { BarProgress, BarProgressContainer, StatsBoxContainer } from './styles';
import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';

type DeviceStatusCardProps = {
  title: string;
  value?: number;
  total?: number;
  color?: string;
  icon?: React.ReactNode;
};

export function DeviceStatusCard({
  title,
  value = 1,
  icon,
  color,
  total = 1,
}: DeviceStatusCardProps) {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Card>
      <Stack direction="row" gap="8px">
        {icon}
        <Typography variant="h4" color={theme.palette.white['06']}>
          {title}
        </Typography>
      </Stack>

      <StatsBoxContainer>
        <Typography variant="h2">{value}</Typography>
        <Typography>{t('dashboard.equipments')}</Typography>
      </StatsBoxContainer>
      <BarProgressContainer>
        <BarProgress
          variant="determinate"
          value={(value * 100) / total}
          color={color}
        />
        <Stack>{Math.round((value * 100) / total)}%</Stack>
      </BarProgressContainer>
    </Card>
  );
}
